module.exports = __webpack_public_path__ + "pc/img/body_basic-1.c12aeae8.png";